module.exports = __webpack_public_path__ + "static/media/31.01.0f89b701.webp";